import { HDate } from '@hebcal/core';

/**
 * Check if a fast day has been postponed (nidcheh) because it fell on Shabbat.
 *
 * Rules:
 * - Ta'anit Esther (13 Adar): moves BACKWARD to Thursday (11 Adar)
 * - Tzom Gedaliah (3 Tishrei): moves forward to Sunday (4 Tishrei)
 * - 17 Tamuz: moves forward to Sunday
 * - 9 Av: moves forward to Sunday (10 Av)
 * - 10 Tevet: never falls on Shabbat
 * - Ta'anit Bechorot (14 Nisan): never falls on Shabbat
 *
 * @param {HDate} hdate
 * @param {object[]} holidays - from calendarProvider
 * @returns {{ isNidcheh: boolean, originalDate: string|null }}
 */
export function computeNidcheh(hdate, holidays) {
  for (const h of holidays) {
    if (h.category === 'fast' && h.isNidcheh) {
      return {
        isNidcheh: true,
        originalDate: h.nameEn,
      };
    }
  }
  return { isNidcheh: false, originalDate: null };
}
